// extracted by mini-css-extract-plugin
module.exports = {"base":"fourteenStories2Ad1Widget-m__base__1ovQM","ad-slot":"fourteenStories2Ad1Widget-m__ad-slot__EBuAe","wrapper":"fourteenStories2Ad1Widget-m__wrapper__1mBbt"};